// extracted by mini-css-extract-plugin
module.exports = {"alertIcon":"NotificationCenter_alertIcon__1qnJO","alertWrapper":"NotificationCenter_alertWrapper__bw-Nu","badge":"NotificationCenter_badge__1Q6ue"};